module.exports = __webpack_public_path__ + "static/media/Mustafa_N_MERIE.e7594caf.pdf";